module.exports = __webpack_public_path__ + "static/media/Roblox_White_SMALL.11e60dae.png";